export const ItemTypes = {
  WORKER: "worker",
};

export const NON_EFFECTIVE_STATUS_CODES = ["TRA", "COF", "RDU"];
export const NON_MOVABLE_STATUS_CODES = ["TRA", "COF", "RDU"];
export const FILTER_STATUS_ORDER = ["SCH", "RAS", "TRA", "RDU", "COF"];